/*global Modernizr */
/*jslint browser:true */

(function() {
  'use strict';

  var stats = document.querySelectorAll('.stats-container .card');

  var observer = new IntersectionObserver(function(entries) {
    entries.forEach((entry) => {
      // isIntersecting is true when element and viewport are overlapping
      // isIntersecting is false when element and viewport don't overlap
      if(entry.isIntersecting === true && !entry.target.classList.contains('stat-shown')) {
        var numbers = entry.target.querySelectorAll('.stat-info span');

        numbers.forEach((number, i) => {
          setTimeout(function() {
            number.classList.add('in');
            number.classList.remove('behind');
          }, 340+(i*95));
        });

        entry.target.classList.add('stat-shown');
      }
    });
  }, { threshold: [0.75] });

  if(stats) {
    stats.forEach((stat) => {
      var content = stat.querySelector('.stat-info').textContent;

      stat.querySelector('.stat-info').innerHTML = '';

      for (var i = 0; i < content.length; i++) {
        var letter = document.createElement('span');

        if(!isNaN(content.charAt(i))) {
          letter.classList.add('number');
        } else {
          letter.classList.add('letter');
        }

        letter.classList.add('behind');

        letter.innerHTML = content.charAt(i);

        stat.querySelector('.stat-info').appendChild(letter);
      }

      observer.observe(stat);
    });
  }
}());

